const actions = {
    FETCH_EMAILS : 'FETCH_EMAILS',
    RECEIVED_EMAILS : 'RECEIVED_EMAILS',
    RESET_EMAIL  : 'RESET_EMAIL',

    fetchEmailsAction: (data) => {
        return {
            type: actions.FETCH_EMAILS,
            data: data
        };
    },
    receivedEmailsAction: (data) => {
        return {
            type: actions.RECEIVED_EMAILS,
            data: data
        };
    },
    resetEmailFormAction: () => {
        return {
            type: actions.RESET_EMAIL,
            data: null
        };
    }
}

export default actions;
